// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3hrwF","alert":"SettungsInbox_alert__2Hm0y"};